import { Box, Typography } from "@mui/material";
import {
  blackColor,
  grayColor,
  lightBlackColor,
  whiteColor,
} from "../constants/colors";

const TextInput = ({
  label,
  value,
  onChange,
  inputStyle,
  labelStyle,
  containerStyle,
  defaultValue,
  placeholder,
  disabled,
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", ...containerStyle }}>
      <Typography
        sx={{
          transition: "color 0.3s",
          marginRight: "8px",
          fontSize: "20px",
          color: disabled ? grayColor : lightBlackColor,
          fontWeight: "500",
          ...labelStyle,
        }}
      >
        {label}
      </Typography>
      <input
        defaultValue={defaultValue}
        placeholder={placeholder}
        disabled={disabled}
        style={{
          all: "unset",
          borderColor: blackColor,
          borderWidth: "1px",
          paddingTop: "1px",
          paddingBottom: "1px",
          backgroundColor: whiteColor,
          borderStyle: "solid",
          color: blackColor,
          fontSize: "20px",
          fontWeight: "500",
          borderRadius: "0px",
          paddingLeft: "2px",
          paddingRight: "2px",
          transition: "all 0.3s",
          ...inputStyle,
        }}
        value={value ?? ""}
        onChange={(event) => onChange(event.target.value)}
      />
    </Box>
  );
};

export default TextInput;
